
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import loges from '../../components/course/loges.vue'
import { CourseModule } from '../../store/modules/course'
  @Component({ 
    components: {
      loges
    } 
  })
export default class AddStorage extends Vue {
    @Prop() dialogGoodsInfo: boolean
    @Prop() GoodsDetailsInfo: any
    @Prop() goodsPageType: string

    storages: any = {
      goods_type_name: '',
      brand: '',
      unit: '',
      model_number: '',
      total: '',
      price: '',
      campus_name: [],
      remark: '',
      history_total: 0
    }
    goodsId: string = ''
    logHeight: number = window.innerHeight - 150
    logesFrom: string = 'edu_goods_info'
    actionBoolean: boolean = false
    intoNumber: number = 0
    outNumber: number = 0
    defTotal: number = 0

    @Watch('dialogGoodsInfo') 
    getStorage(newVal, oldVal) {
      if (newVal) {
        this.storages = {
          goods_type_name: this.GoodsDetailsInfo.goods_type_name,
          brand: this.GoodsDetailsInfo.brand,
          unit: this.GoodsDetailsInfo.unit,
          model_number: this.GoodsDetailsInfo.model_number,
          total: this.GoodsDetailsInfo.total,
          price: this.GoodsDetailsInfo.price,
          campus_name: this.GoodsDetailsInfo.campus_name,
          remark: this.GoodsDetailsInfo.remark,
          service_total: this.GoodsDetailsInfo.service_total,
          history_total: this.GoodsDetailsInfo.total + this.GoodsDetailsInfo.sale_total + this.GoodsDetailsInfo.service_total
        }
        this.defTotal = this.GoodsDetailsInfo.total,
        this.goodsId = this.GoodsDetailsInfo.info_id
        this.actionBoolean = true
      }
    }
    getNumber(val) {
      this.storages.history_total = Number(val) + this.GoodsDetailsInfo.sale_total + this.GoodsDetailsInfo.service_total
    }
    getIntoNumber(val) {
      this.storages.total = this.intoNumber - this.outNumber + this.defTotal
      this.getNumber(this.storages.total)
    }
    getOutNumber(val) {
      this.storages.total = this.intoNumber - this.outNumber + this.defTotal
      this.getNumber(this.storages.total)
    }
    close() {
      this.$emit('goods-details', { type: false, data: {} })
      this.actionBoolean = false
    }
    async editGoods() {
      let data = {}
      if (this.goodsPageType === 'edu-goods-sale-page') {
        data = {
          id: this.GoodsDetailsInfo.info_id,
          model_number: this.GoodsDetailsInfo.model_number,
          price: Number(this.storages.price),
          total: Number(this.storages.total)
        }
      } else {
        data = {
          id: this.GoodsDetailsInfo.info_id,
          model_number: this.GoodsDetailsInfo.model_number,
          price: Number(this.storages.price),
          service_total: Number(this.storages.service_total),
          total: this.GoodsDetailsInfo.history_total - Number(this.storages.service_total) - this.GoodsDetailsInfo.sale_total
        }
      }
      
      if (this.goodsPageType === 'edu-goods-sale-page') {
        data['history_total'] = this.storages.history_total
      }
      this.$emit('goods-details', { type: true, data: data })
      this.actionBoolean = false
    }
    submit() {
      this.editGoods()
    }

    mounted() {
     
    }
}
